var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40786 14.4374C4.70193 13.6905 3.40772 12.2411 3.50521 11.2125C10.5309 7.96391 18.5718 7.47509 26.1588 8.44255C26.8278 8.60209 28.9691 11.5112 28.4077 11.9491C27.1404 11.7998 25.8731 11.6606 24.5991 11.5757C19.4256 11.311 14.1681 11.7794 9.21316 13.3613C8.08031 13.7279 6.9878 14.1794 5.91546 14.6886C5.73393 14.7666 5.51879 14.5256 5.41122 14.4374H5.40786Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95851 24.7344C7.23914 23.9638 5.97182 22.5687 6.0525 21.5096C12.2445 18.502 19.3979 18.339 26.0471 19.6256C26.7127 19.7885 28.8574 22.6943 28.2927 23.1322C25.8757 22.7282 23.4352 22.3752 20.9812 22.3412C16.702 22.3412 12.3353 23.1084 8.46275 24.9856C8.28122 25.0671 8.05936 24.8193 7.95851 24.7344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderOpen);
export default __webpack_public_path__ + "static/media/HeaderOpen.30f54256a860d9d39063070592feb3e0.svg";
export { ForwardRef as ReactComponent };